import React from "react";
import { useSelector } from "react-redux";
import {
  Header as AppBar,
  Tabs,
  Tab,
  ProgressBar,
} from "@airbus/components-react";
import { Link } from "react-router-dom";
import "./Header.scss";
import { redirectToGDDashboard } from "../../utils/data.request";

const Header = () => {
  const { zipFilenames, zipDownload } = useSelector((store) => store.loading);
  const dossierStatus = useSelector((store) => store.dossierStatus);
  return (
    <div className="exclude-print header-cls" data-testid="header-root">
      <AppBar
        style={{ position: "sticky", marginBottom: "1px" }}
        appName="MPO PBS"
      >
        <Tabs>
          { dossierStatus?.dossierType 
            && dossierStatus?.dossierKey 
            && dossierStatus?.exerciseNameKey
            && (
          <Tab>
          <a href={redirectToGDDashboard(dossierStatus)} 
            target="_blank" rel="noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}>
            Graphic Dashboard
            </a>
          </Tab>
            )}
          <Tab component={Link} to="/signout">SignOut</Tab>
        </Tabs>
      </AppBar>
      <div className="progress-bar">
        {zipFilenames || zipDownload ? <ProgressBar indeterminate /> : false}
      </div>
    </div>
  );
};
export default Header;
